import { Schema as S } from "effect";

export const ListSchedulesRequestSchema = S.Struct({
  // Date range filters - API docs show start/end as the documented params
  start: S.optional(S.String),
  end: S.optional(S.String),
  // Suffix variants (may or may not work depending on doc-cirrus version)
  start_gte: S.optional(S.String),
  start_lte: S.optional(S.String),
  end_gte: S.optional(S.String),
  end_lte: S.optional(S.String),
  // Other filters
  closeTime: S.optional(S.Boolean),
  closeDayType: S.optional(S.String),
  calendar: S.optional(S.String),
  patient: S.optional(S.String),
  scheduled: S.optional(S.Number),
  isReadOnly: S.optional(S.String),
  resourceBased: S.optional(S.Boolean),

  // sorting and pagination
  sort: S.optional(S.String),
  page: S.optional(S.Number),
  itemsPerPage: S.optional(S.Number),
  noCountLimit: S.optional(S.Union([S.Literal("true"), S.Literal("false")])),

  // creation date filters
  creationDate: S.optional(S.String),
  creationDate_lt: S.optional(S.String),
  creationDate_gt: S.optional(S.String),
});

export type ListSchedulesRequest = S.Schema.Type<
  typeof ListSchedulesRequestSchema
>;
